import { createContext } from "react";
export default createContext({
    setSelectedAustralianState: () => undefined,
    selectedAustralianState: undefined,
});
